import React from 'react';
import { Box, Heading, Text, VStack, Button } from '@chakra-ui/react';

export default function PioneerSection() {
  return (
    <Box
      as="section"
      aria-label="Deviens un pionnier"
      style={{ backgroundImage: "linear-gradient(103.25deg, rgb(199, 229, 244) 3.39%, rgb(177, 240, 173) 30.70%, rgb(199, 229, 244) 98.53%)" }}
      borderRadius="40px"
      h={{ base: "275px", md: "356px" }}
      px={{ base: "20px", md: "20px" }}
      py={{ base: "20px", md: "20px" }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <VStack gap="20px">
        <Heading
          as="h2"
          fontSize={{ base: "30px", md: "45px" }}
          fontWeight="bold"
          fontFamily="Inter, sans-serif"
          color="black"
          textAlign="center"
          letterSpacing="0.1px"
          lineHeight="1.2"
        >
          Résonance est créé en 2026 !
        </Heading>
        <Text
          fontSize={{ base: "18px", md: "20px" }}
          fontFamily="Inter, sans-serif"
          fontWeight="normal"
          color="black"
          textAlign="center"
          letterSpacing="0.1px"
        >
          Deviens un pionnier !
        </Text>
        <Button
          as="a"
          href="https://discord.gg/qJhmqbmcb2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Rejoins le Discord
        </Button>
      </VStack>
    </Box>
  );
}
